(() => {
  const q = (selector, scope = document) => scope.querySelector(selector);
  const qa = (selector, scope = document) => [...scope.querySelectorAll(selector)];

  function initHeader(root) {
    if (!root || root.dataset.bound) return;
    root.dataset.bound = 'true';
    const megaButtons = qa('[data-kexs-mega-button]', root);
    const megaPanels = qa('[data-kexs-mega]', root);
    const headerScrim = q('[data-kexs-header-scrim]', root);
    const search = q('[data-kexs-search]', root);
    const searchInput = search && q('input[type="search"]', search);
    const drawer = q('[data-kexs-drawer]', document);
    const drawerScrim = q('[data-kexs-drawer-scrim]', document);
    const productTypeSelect = q('.js-search-product-types', root);

    // Keep the visible product-type selector and the submitted search filter
    // synchronized even when Shopify swaps between predictive and standard search.
    productTypeSelect?.addEventListener('change', (event) => {
      const form = productTypeSelect.closest('form');
      const productTypeInput = q('input[name="filter.p.product_type"]', form || root);
      const selectedValue = event.detail?.selectedValue ?? '';
      if (productTypeInput) productTypeInput.value = selectedValue;

      const queryInput = q('input[type="search"]', form || root);
      if (queryInput?.value.trim()) {
        queryInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });

    const closeMegas = () => {
      megaButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
      megaPanels.forEach((panel) => panel.classList.remove('is-open'));
      headerScrim?.classList.remove('is-open');
    };
    const closeSearch = () => {
      search?.classList.remove('is-open');
      q('[data-kexs-search-open]', root)?.setAttribute('aria-expanded', 'false');
      headerScrim?.classList.remove('is-open');
    };
    const closeDrawer = () => {
      drawer?.classList.remove('is-open');
      drawerScrim?.classList.remove('is-open');
      q('[data-kexs-drawer-open]', root)?.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('kexs-menu-open');
      document.documentElement.style.overflow = '';
    };
    const openDrawer = () => {
      closeMegas();
      closeSearch();
      document.documentElement.classList.add('kexs-menu-open');
      drawer?.classList.add('is-open');
      drawerScrim?.classList.add('is-open');
      q('[data-kexs-drawer-open]', root)?.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
    };

    megaButtons.forEach((button) => {
      const id = button.dataset.kexsMegaButton;
      const open = () => {
        closeSearch();
        megaButtons.forEach((item) => item.setAttribute('aria-expanded', String(item === button)));
        megaPanels.forEach((panel) => panel.classList.toggle('is-open', panel.dataset.kexsMega === id));
        headerScrim?.classList.remove('is-open');
      };
      button.addEventListener('mouseenter', open);
      button.addEventListener('focus', open);
    });
    qa('.kexs-header__navlink:not([data-kexs-mega-button])', root).forEach((link) => {
      link.addEventListener('mouseenter', closeMegas);
      link.addEventListener('focus', closeMegas);
    });
    megaPanels.forEach((panel) => {
      panel.addEventListener('mouseleave', closeMegas);
      const preview = q('[data-kexs-menu-preview]', panel);
      const previewImage = q('[data-kexs-preview-image]', preview || panel);
      const previewTitle = q('[data-kexs-preview-title]', preview || panel);
      const fallback = q('.kexs-header__preview-fallback', preview || panel);
      let previewTimer;
      const updatePreview = (source) => {
        if (!preview || !source) return;
        const nextImage = source.dataset.kexsPreviewImage;
        const nextTitle = source.dataset.kexsPreviewTitle;
        if (nextTitle && previewTitle) previewTitle.textContent = nextTitle;
        if (!nextImage || !previewImage || previewImage.src === nextImage) return;
        window.clearTimeout(previewTimer);
        preview.classList.add('is-changing');
        const loader = new Image();
        loader.onload = () => {
          previewTimer = window.setTimeout(() => {
            previewImage.src = nextImage;
            previewImage.alt = nextTitle || '';
            previewImage.hidden = false;
            if (fallback) fallback.hidden = true;
            preview.classList.remove('is-changing');
          }, 90);
        };
        loader.src = nextImage;
      };
      qa('[data-kexs-preview-source]', panel).forEach((source) => {
        source.addEventListener('mouseenter', () => updatePreview(source));
        source.addEventListener('focus', () => updatePreview(source));
      });
    });

    q('[data-kexs-search-open]', root)?.addEventListener('click', () => {
      closeMegas();
      const next = !search?.classList.contains('is-open');
      search?.classList.toggle('is-open', next);
      q('[data-kexs-search-open]', root)?.setAttribute('aria-expanded', String(next));
      headerScrim?.classList.toggle('is-open', next);
      if (next) window.setTimeout(() => searchInput?.focus(), 120);
    });
    q('[data-kexs-search-close]', root)?.addEventListener('click', closeSearch);
    headerScrim?.addEventListener('click', () => { closeMegas(); closeSearch(); });
    q('[data-kexs-drawer-open]', root)?.addEventListener('click', openDrawer);
    q('[data-kexs-drawer-close]', document)?.addEventListener('click', closeDrawer);
    drawerScrim?.addEventListener('click', closeDrawer);
    qa('[data-kexs-drawer-accordion]', drawer || document).forEach((button) => {
      button.addEventListener('click', () => {
        const item = button.closest('.kexs-drawer__item');
        const next = !item?.classList.contains('is-open');
        item?.classList.toggle('is-open', next);
        button.setAttribute('aria-expanded', String(next));
      });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { closeMegas(); closeSearch(); closeDrawer(); }
    });
  }

  function initHero(root) {
    if (!root || root.dataset.bound) return;
    root.dataset.bound = 'true';
    const slides = qa('[data-kexs-slide]', root);
    const lines = qa('[data-kexs-line]', root);
    if (slides.length < 2) return;
    let current = 0;
    let timer;
    const seconds = Number(root.dataset.autoplay || 0);
    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === current);
        slide.setAttribute('aria-hidden', String(i !== current));
      });
      lines.forEach((line, i) => {
        line.classList.toggle('is-active', i === current);
        line.setAttribute('aria-selected', String(i === current));
      });
    };
    const restart = () => {
      window.clearInterval(timer);
      if (seconds > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = window.setInterval(() => show(current + 1), seconds * 1000);
      }
    };
    lines.forEach((line, index) => line.addEventListener('click', () => { show(index); restart(); }));
    q('[data-kexs-prev]', root)?.addEventListener('click', () => { show(current - 1); restart(); });
    q('[data-kexs-next]', root)?.addEventListener('click', () => { show(current + 1); restart(); });
    root.addEventListener('mouseenter', () => window.clearInterval(timer));
    root.addEventListener('mouseleave', restart);
    show(0);
    restart();
  }

  function initServices(root) {
    if (!root || root.dataset.bound) return;
    root.dataset.bound = 'true';
    const items = qa('[data-kexs-service]', root);
    if (!items.length) return;
    const enabled = root.dataset.autoplay === 'true';
    const interval = Math.max(2000, Number(root.dataset.interval || 2500));
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let current = 0;
    let timer;
    let hovering = false;

    const activate = (index) => {
      current = (index + items.length) % items.length;
      items.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === current));
    };
    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (enabled && !reduceMotion && !hovering && items.length > 1) {
        timer = window.setInterval(() => activate(current + 1), interval);
      }
    };

    items.forEach((item, index) => {
      item.addEventListener('mouseenter', () => { hovering = true; stop(); activate(index); });
      item.addEventListener('mouseleave', () => { hovering = false; start(); });
      item.addEventListener('focusin', () => { hovering = true; stop(); activate(index); });
      item.addEventListener('focusout', () => { hovering = false; start(); });
    });
    activate(0);
    start();
  }

  function bindKexSwipe(surface, getConfig) {
    if (!surface || surface.dataset.kexSwipeBound) return;
    surface.dataset.kexSwipeBound = 'true';
    let pointerId = null;
    let startX = 0;
    let startY = 0;
    let deltaX = 0;
    let dragging = false;
    let suppressClick = false;
    let config = null;

    const begin = (id, clientX, clientY, target) => {
      if (pointerId !== null || target?.closest?.('button,input,select,textarea')) return false;
      config = getConfig();
      if (!config?.track || !config?.step?.()) return false;
      pointerId = id;
      startX = clientX;
      startY = clientY;
      deltaX = 0;
      dragging = false;
      config.onStart?.();
      return true;
    };

    const move = (id, clientX, clientY, event, canCapture = false) => {
      if (pointerId === null || id !== pointerId || !config?.track) return;
      const moveX = clientX - startX;
      const moveY = clientY - startY;
      if (!dragging && Math.abs(moveX) < 12) return;
      if (!dragging && Math.abs(moveY) > Math.abs(moveX)) return;
      dragging = true;
      deltaX = moveX;
      if (canCapture) surface.setPointerCapture?.(id);
      config.track.classList.add('is-dragging');
      config.track.style.transform = `translate3d(${config.base() + deltaX}px,0,0)`;
      if (event?.cancelable) event.preventDefault();
    };

    const finish = (id) => {
      if (pointerId === null || id !== pointerId) return;
      const wasDragging = dragging;
      const threshold = Math.max(34, Math.min(72, (config?.step?.() || 150) * .2));
      config?.track?.classList.remove('is-dragging');
      config?.onEnd?.();

      if (wasDragging && Math.abs(deltaX) >= threshold) {
        deltaX < 0 ? config?.next?.() : config?.previous?.();
      } else {
        config?.settle?.();
      }

      if (wasDragging) {
        suppressClick = true;
        window.setTimeout(() => { suppressClick = false; }, 80);
      }
      pointerId = null;
      dragging = false;
      deltaX = 0;
      config = null;
    };

    surface.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch') return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      begin(event.pointerId, event.clientX, event.clientY, event.target);
    });

    surface.addEventListener('pointermove', (event) => {
      if (event.pointerType === 'touch') return;
      move(event.pointerId, event.clientX, event.clientY, event, true);
    }, { passive: false });

    surface.addEventListener('pointerup', (event) => {
      if (event.pointerType !== 'touch') finish(event.pointerId);
    });
    surface.addEventListener('pointercancel', (event) => {
      if (event.pointerType !== 'touch') finish(event.pointerId);
    });
    surface.addEventListener('lostpointercapture', (event) => finish(event.pointerId));

    surface.addEventListener('touchstart', (event) => {
      if (event.touches.length !== 1) return;
      const touch = event.touches[0];
      begin(touch.identifier, touch.clientX, touch.clientY, event.target);
    }, { passive: true });
    surface.addEventListener('touchmove', (event) => {
      const touch = Array.from(event.touches).find((item) => item.identifier === pointerId);
      if (touch) move(touch.identifier, touch.clientX, touch.clientY, event);
    }, { passive: false });
    surface.addEventListener('touchend', (event) => {
      const touch = Array.from(event.changedTouches).find((item) => item.identifier === pointerId);
      if (touch) finish(touch.identifier);
    }, { passive: true });
    surface.addEventListener('touchcancel', (event) => {
      const touch = Array.from(event.changedTouches).find((item) => item.identifier === pointerId);
      if (touch) finish(touch.identifier);
    }, { passive: true });
    surface.addEventListener('click', (event) => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);
  }

  function initCatalogSlider(root) {
    if (!root || root.dataset.bound) return;
    root.dataset.bound = 'true';
    const track = q('.kexs-catalog-rail__track', root);
    const viewport = q('.kexs-catalog-rail__viewport', root);
    const firstGroup = q('.kexs-catalog-rail__group', root);
    const firstCard = q('.kexs-catalog-rail__card', firstGroup);
    if (!track || !viewport || !firstGroup || !firstCard) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const total = qa('.kexs-catalog-rail__card', firstGroup).length;
    const interval = Math.max(4000, Number(root.dataset.interval || 6000));
    let current = 0;
    let timer;
    let paused = false;
    let locked = false;

    const stepWidth = () => {
      const styles = window.getComputedStyle(firstGroup);
      return firstCard.offsetWidth + (parseFloat(styles.columnGap || styles.gap) || 0);
    };
    const fitViewport = () => {
      const cardWidth = firstCard.offsetWidth;
      const step = stepWidth();
      if (!cardWidth || !step) return;
      const gap = Math.max(0, step - cardWidth);
      const available = root.getBoundingClientRect().width;
      const preferred = window.innerWidth <= 749 ? 2 : window.innerWidth <= 1100 ? 4 : 7;
      const fitting = Math.max(1, Math.floor((available + gap) / step));
      const visible = Math.min(total, preferred, fitting);
      const exactWidth = cardWidth + Math.max(0, visible - 1) * step;
      viewport.style.width = `min(100%, ${Math.ceil(exactWidth)}px)`;
      viewport.dataset.kexCatalogVisible = String(visible);
    };
    const render = (animate = true) => {
      track.classList.toggle('is-resetting', !animate);
      track.style.transform = `translate3d(${-current * stepWidth()}px,0,0)`;
      if (!animate) requestAnimationFrame(() => track.classList.remove('is-resetting'));
    };
    const next = (force = false) => {
      if (locked && !force) return;
      locked = true;
      current += 1;
      render(true);
      if (current >= total) {
        window.setTimeout(() => { current = 0; render(false); }, 760);
      }
      window.setTimeout(() => { locked = false; }, 780);
    };
    const previous = (force = false) => {
      if (locked && !force) return;
      locked = true;
      if (current === 0) {
        current = total;
        render(false);
        window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
          current = total - 1;
          render(true);
        }));
      } else {
        current -= 1;
        render(true);
      }
      window.setTimeout(() => { locked = false; }, 780);
    };
    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (window.innerWidth > 749 && !reduceMotion && !paused && total > 1) timer = window.setInterval(next, interval);
    };
    root.addEventListener('mouseenter', () => { paused = true; stop(); });
    root.addEventListener('mouseleave', () => { paused = false; start(); });
    root.addEventListener('focusin', () => { paused = true; stop(); });
    root.addEventListener('focusout', () => { paused = false; start(); });
    q('[data-kexs-catalog-prev]', root)?.addEventListener('click', previous);
    q('[data-kexs-catalog-next]', root)?.addEventListener('click', next);
    bindKexSwipe(viewport, () => ({
      track,
      step: stepWidth,
      base: () => -current * stepWidth(),
      previous: () => previous(true),
      next: () => next(true),
      settle: () => render(true),
      onStart: () => { paused = true; stop(); },
      onEnd: () => { paused = false; start(); }
    }));
    window.addEventListener('resize', () => { fitViewport(); current = 0; render(false); });
    fitViewport();
    render(false);
    start();
  }

  function initProductsSlider(root) {
    if (!root || root.dataset.productsBound) return;
    root.dataset.productsBound = 'true';
    const tabs = qa('[data-kexs-products-tab]', root);
    const panels = qa('[data-kexs-products-panel]', root);
    if (!panels.length) return;
    let current = 0;
    let activePanel = panels.find((panel) => !panel.hidden) || panels[0];
    let timer;
    let paused = false;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const interval = 5200;
    const visible = () => window.innerWidth <= 749 ? 2 : window.innerWidth <= 1100 ? 3 : 4;
    const activeItems = () => ({
      track: q('[data-kexs-products-track]', activePanel),
      cards: qa('.kexs-product', activePanel)
    });
    const stepWidth = () => {
      const { track, cards } = activeItems();
      if (!track || !cards.length) return 0;
      const styles = window.getComputedStyle(track);
      return cards[0].getBoundingClientRect().width + (parseFloat(styles.columnGap || styles.gap) || 0);
    };
    const render = () => {
      const { track } = activeItems();
      if (track) track.style.transform = `translate3d(${-current * stepWidth()}px,0,0)`;
    };
    const next = () => { const { cards } = activeItems(); const max = Math.max(0, cards.length - visible()); current = current >= max ? 0 : current + 1; render(); };
    const previous = () => { const { cards } = activeItems(); const max = Math.max(0, cards.length - visible()); current = current <= 0 ? max : current - 1; render(); };
    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      const { cards } = activeItems();
      if (window.innerWidth > 749 && !reduceMotion && !paused && cards.length > visible()) timer = window.setInterval(next, interval);
    };
    const activate = (id) => {
      const nextPanel = panels.find((panel) => panel.dataset.kexsProductsPanel === id);
      if (!nextPanel) return;
      activePanel = nextPanel;
      current = 0;
      panels.forEach((panel) => { panel.hidden = panel !== activePanel; });
      tabs.forEach((tab) => {
        const selected = tab.dataset.kexsProductsTab === id;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', String(selected));
      });
      render();
      start();
    };
    tabs.forEach((tab) => tab.addEventListener('click', () => activate(tab.dataset.kexsProductsTab)));
    q('[data-kexs-products-prev]', root)?.addEventListener('click', () => { previous(); start(); });
    q('[data-kexs-products-next]', root)?.addEventListener('click', () => { next(); start(); });
    bindKexSwipe(q('.kexs-products__slider', root), () => {
      const { track } = activeItems();
      return {
        track,
        step: stepWidth,
        base: () => -current * stepWidth(),
        previous,
        next,
        settle: render,
        onStart: () => { paused = true; stop(); },
        onEnd: () => { paused = false; start(); }
      };
    });
    root.addEventListener('mouseenter', () => { paused = true; stop(); });
    root.addEventListener('mouseleave', () => { paused = false; start(); });
    root.addEventListener('focusin', () => { paused = true; stop(); });
    root.addEventListener('focusout', () => { paused = false; start(); });
    window.addEventListener('resize', () => { current = 0; render(); start(); });
    document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); else start(); });
    render();
    start();
  }

  function initAll(scope = document) {
    qa('[data-kexs-header]', scope).forEach(initHeader);
    qa('[data-kexs-hero]', scope).forEach(initHero);
    qa('[data-kexs-catalog-slider]', scope).forEach(initCatalogSlider);
    qa('[data-kexs-products-slider]', scope).forEach(initProductsSlider);
    qa('[data-kexs-services]', scope).forEach(initServices);
  }

  if (!document.documentElement.dataset.kexsCartDrawerBridge) {
    document.documentElement.dataset.kexsCartDrawerBridge = 'true';
    document.addEventListener('click', (event) => {
      const drawer = q('cart-drawer');
      if (!drawer || !drawer.hasAttribute('open')) return;
      const closeControl = event.target.closest?.('cart-drawer .js-close-drawer');
      const activeOverlay = event.target.closest?.('.js-overlay.is-visible');
      if (closeControl || activeOverlay) drawer.close();
    }, true);
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => initAll()) : initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
